import {
  MODAL_HIDDEN,
  MODAL_INTERACTION,
  MODAL_DATA_LOADED,
} from '../actions/constants';
import OrderByKey from '../components/layers/OrderByKey';
import { ORDER_BY } from '../util/enums/EnumLayers';
import ModalOrderBy from '../components/modals/ModalOrderBy';
import { NULLS_SMALL } from '../util/enums/EnumNullOrder';

const INITIAL_STATE = {
  selected: [], // OrderByKey
  limit: null, // a number of rows to limit by (e.g. 5 for top 5 rows)
  plusClicked: false,
  readyForSave: false,
  nulls: NULLS_SMALL, // default to NULLS_SMALL
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'addColumn': {
      const newColumn = new OrderByKey(payload.columnName, true);
      return {
        ...state,
        selected: [...state.selected, newColumn],
        plusClicked: false,
      };
    }
    case 'removeColumn':
      return {
        ...state,
        selected: state.selected.filter(
          (o) => !o.columnName().equals(payload.columnName),
        ),
      };
    case 'limit':
      return { ...state, limit: payload.value };
    case 'toggleDir':
      return {
        ...state,
        selected: state.selected.map((o) => {
          if (!o.columnName().equals(payload.columnName)) {
            return o;
          }
          return new OrderByKey(o.columnName(), !o.desc());
        }),
      };
    case 'plusClicked':
      return { ...state, plusClicked: true };
    default:
      return state;
  }
}

const modalOrderBy = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalOrderBy) {
        if (action.payload.relevantColumnName) {
          const orderByKey = new OrderByKey(
            action.payload.relevantColumnName,
            true,
          );
          return { ...state, selected: [orderByKey], readyForSave: true };
        }
        if (action.payload.existingLayer) {
          return {
            ...state,
            selected: action.payload.existingLayer.keys(),
            nulls: action.payload.existingLayer.nullsOrder(),
            limit: action.payload.existingLayer.limit(),
            plusClicked: false,
            readyForSave: true,
          };
        }
      }
      return state;
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== ORDER_BY) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      newState.readyForSave = newState.selected.length > 0;
      return newState;
    }
    default:
      return state;
  }
};

export default modalOrderBy;
